import styled from "styled-components";

export const StripeFormWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const StripeElementWrapper = styled.div`
  min-height: 120px;
`;

export const StripeAmount = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.textSubtle};
  text-align: center;
  font-size: 14px;
`;

export const StripeEditButton = styled.button`
  align-self: center;
  border: 0;
  padding: 0;
  background: transparent;
  color: ${({ theme }) => theme.primary};
  text-decoration: underline;

  &:disabled {
    cursor: default;
    opacity: 0.5;
  }
`;
